import { spiritIslandChapters } from './content';
export const spiritIslandCommonMistakes = spiritIslandChapters.find((chapter) => chapter.title.toLocaleUpperCase('pl').includes('NAJCZĘSTSZE BŁĘDY'));
